/**
 * A tap on FIX, FOUND or ADDED in the field grid or the search overlay (B-254, P2-2 part A,
 * Phase 2). The host wires it to its own row update; the grid only calls it.
 *
 * D-12 — THE ORDER IS write → host update → enqueue, and each step has a reason:
 *   - The write goes first, so a throw claims nothing. D-11: a tap racing a re-key finds its
 *     pending row already deleted by reconcile, updateWorkingField throws "record … not
 *     found", and the tap simply does not take. The box stays where it was; no message, no new
 *     grid surface; a second tap a moment later lands on the re-keyed row.
 *   - The host update goes BEFORE the enqueue. The tick shows about twice as soon (measured
 *     127 ms against 322 ms at the p90 site, 4x CPU), for the same total work.
 *
 * D-4: true goes to false; false or blank goes to true. Never back to blank.
 *
 * Resolves to what happened. Nothing on screen reads it (the grid has no surface for write
 * outcomes); it names the cases for the tests and the log:
 *   'queued'    — enqueueFieldCapture returned an outbox id, OR CAPTURE_HELD. Held is success:
 *                 the record has an unsettled capture (B-206) and this tick goes out when that
 *                 one settles. Never nothing-to-send.
 *   'unqueued'  — it returned null: a pending row (refused on purpose, D-5.2b-E; the value
 *                 rides the re-key's follow-up capture) or an empty diff.
 *   'not-taken' — the write threw (D-11).
 *   'error'     — the write landed but the local enqueue failed. The row stays dirty and
 *                 tinted, and the sync sheet lists it as unsent.
 */
import { updateWorkingField } from '../db/fieldStore';
import { enqueueFieldCapture } from '../sync/fieldOutbox';

export async function tapFlag(record, key, onRecordChange) {
  const next = record.working?.[key] !== true;
  let updated;
  try {
    updated = await updateWorkingField(record.record_id, key, next);
  } catch (err) {
    console.warn(`[flagTap] ${key} on ${record.record_id} did not take (D-11): ${err?.message}`);
    return 'not-taken';
  }
  onRecordChange(updated);
  try {
    // An outbox id and CAPTURE_HELD are both truthy, which is the point: both are queued.
    return (await enqueueFieldCapture(updated)) ? 'queued' : 'unqueued';
  } catch (err) {
    console.error(`[flagTap] ${key} on ${record.record_id} was written but not queued:`, err);
    return 'error';
  }
}
